export default __webpack_public_path__ + "static/product-44ed55eab75ac4e72af8a770f9631ed8.webp";